import { createAction, createRequestTypes, FAILURE, REQUEST, SUCCESS } from '../../../utils/actionGenerator';

export const GET_LANE_RATE_LIST = createRequestTypes('GET_LANE_RATE_LIST');

export const getLaneRateList = {
  request: (params) => createAction(GET_LANE_RATE_LIST[REQUEST], { params }),
  success: (response) => createAction(GET_LANE_RATE_LIST[SUCCESS], { response }),
  failure: (response) => createAction(GET_LANE_RATE_LIST[FAILURE], { response }),
};

